

module.exports = __webpack_require__.stylable.create(
    "widget2002176778",
    {"classes":{"root":"widget2002176778__root","content":"widget2002176778__content","mobile":"widget2002176778__mobile","buttonContainer":"widget2002176778__buttonContainer","hiddenFiltersSpacing":"widget2002176778__hiddenFiltersSpacing"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "widget2002176778",
    null
);
